import css from '../../../utils/css';

const defaultTheme: string = css`
  :host {
    --odds-grid-border: color-mix(in srgb, #f2f5f6 90%, black);
    --odds-grid-bg: #ffffff;
    --odds-button-bg: #f2f5f6;
    --odds-button-text: #333;
    --odds-button-hover-bg: color-mix(in srgb, #f2f5f6 90%, black);
    --odds-button-highlight-bg: #022e4a;
    --odds-button-highlight-text: white;
    --no-odds-bg: #f2f5f6;
    --no-odds-text: #333;
    --live-indicator-color: red;
    --header-text-color: #000;
    --odds-grid-vertical-font-family: inherit;
    --odds-grid-border-radius: 4px;
  }
`;

export default defaultTheme;
